import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=3c9e3338&scoped=true&"
import script from "./productForm.vue?vue&type=script&lang=js&"
export * from "./productForm.vue?vue&type=script&lang=js&"
import style0 from "./productForm.vue?vue&type=style&index=0&id=3c9e3338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e3338",
  null
  
)

export default component.exports